const DocumentStatusesEnum = {
    EMPTY: 'Empty',
    UPLOADED: 'Uploaded',
    AWAITING: 'Awaiting',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
}
export default DocumentStatusesEnum;
